<template>
    <div
        v-if="isOpen"
        v-click-outside="() => $emit('close')"
        class="absolute transform -translate-x-[60%] z-10 mt-2 bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg w-60 p-4 flex-col items-start gap-3"
    >
        <template v-if="trip.payment_points === 0">
            <p class="text-slate-500 dark:text-slate-400 text-[12px] font-medium">
                Details will display once you begin to add redemptions to this
                trip.
            </p>
        </template>
        <template v-else>
            <div
                class="flex justify-between mb-3"
                v-for="program in computedPointsPrograms"
                :key="program.payment_program_id"
            >
                <ImageLoader v-if="variant === 'mobile'">
                    <template #image>
                        <img
                            :src="
                                program.payment_program.image
                                    ? program.payment_program.image.replace(
                                          'storage',
                                          'images'
                                      )
                                    : `${cdnUrl}/${program?.payment_program?.program_image?.path}/_small/${program?.payment_program?.program_image?.file_name}`
                            "
                            :title="program.payment_program?.name"
                            class="mw-[160px] h-[20px]"
                        />
                    </template>
                    <template #error>
                        <Icon
                            icon="points"
                            class="text-slate-600 dark:text-slate-300 w-8 h-5"
                        />
                        <span>{{ program.payment_program?.name }}</span>
                    </template>
                </ImageLoader>
                <img
                    v-else
                    :src="`${cdnUrl}/${program?.payment_program?.program_image?.path}/_small/${program?.payment_program?.program_image?.file_name}`"
                    :title="program.payment_program?.name"
                    :alt="program.payment_program?.name"
                    class="mw-[160px] h-[20px]"
                />
                <span class="text-[12px] text-slate-800 dark:text-slate-100">
                    {{ formatNumber(program.payment_points) }}
                </span>
            </div>
            <div class="mt-2 w-52 h-0.5 bg-[#E2E8F0]"></div>
            <div class="mt-4 flex justify-between">
                <h3 class="text-slate-500 dark:text-slate-400 text-[12px] font-medium">Total</h3>
                <span class="text-[12px] text-right text-slate-800 dark:text-slate-100">
                    {{ formatNumber(trip.payment_points) }}
                </span>
            </div>
        </template>
    </div>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';
import ImageLoader from '@/components/ui/image-loader/image-loader.vue';

defineProps({
    isOpen: { type: Boolean, default: false },
    trip: { type: Object, required: true },
    computedPointsPrograms: { type: Array, default: () => [] },
    cdnUrl: { type: String, default: '' },
    formatNumber: { type: Function, required: true },
    variant: { type: String, default: 'desktop' },
});

defineEmits(['close']);
</script>
